module.exports = __webpack_public_path__ + "static/media/students.5adb92e0.svg";